module.exports = __webpack_public_path__ + "img/EXTERIOR-FRONX-BOOSTERGREEN-3.e135d222.jpg";